// This file is auto-generated. Do not edit manually.
// Generated from PostHog project(s): 89553, 89551
export const featureFlags = [
  "abstract-forms",
  "ai-hotline",
  "allow-cases-export",
  "background-exports",
  "background-processes",
  "document-management",
  "force-session-recording",
  "integration-adp",
  "integration-paylocity",
  "integration-rippling",
  "integration-teams",
  "integration-ukg-ready",
  "investigations",
  "invoicing-hotline-credits",
  "invoicing-hotline-credits-auto-refill",
  "maintenance"
] as const

// Generated for production with any type to allow all feature flags
export type FeatureFlag = any
